module.exports = __webpack_public_path__ + "img/24-4.4e76b64e.png";